import { useLanguage } from '../context/LanguageContext';
import { legalContent } from '../data/legalContent';
import AnimateIn from '../components/AnimateIn';

export default function LegalPage({ type }) {
  const { language } = useLanguage();
  const content = legalContent[type];

  return (
    <div className="pt-32 md:pt-40 pb-20 md:pb-28 px-6 lg:px-8" data-testid={`${type}-page`}>
      <div className="max-w-3xl mx-auto">
        <AnimateIn>
          <h1
            className="text-3xl md:text-5xl font-bold tracking-[-0.02em] text-white mb-3"
            style={{ fontFamily: "'Syne', sans-serif" }}
            data-testid={`${type}-title`}
          >
            {content.title[language]}
          </h1>
          <p className="text-xs mb-10 text-gray-500">{content.updated[language]}</p>
          <p className="text-sm leading-[1.9] mb-12 text-gray-400">
            {content.intro[language]}
          </p>
        </AnimateIn>

        <div className="space-y-10">
          {content.sections.map((section, i) => (
            <AnimateIn key={i} delay={Math.min(i * 0.04, 0.3)}>
              <div data-testid={`${type}-section-${i}`}>
                <h2
                  className="text-lg font-semibold text-white mb-3"
                  style={{ fontFamily: "'Syne', sans-serif" }}
                >
                  {section.h[language]}
                </h2>
                {section.p.map((para, pi) => (
                  <p key={pi} className="text-sm leading-[1.9] text-gray-400">
                    {para[language]}
                  </p>
                ))}
              </div>
            </AnimateIn>
          ))}
        </div>
      </div>
    </div>
  );
}
